<template>
  <section
    id="upload-receipt-guidelines-drawer"
    :class="{ 'for-desktop': isModal }"
  >
    <div class="guidelines-scroll-content">
      <h5 class="text-center">
        {{ isOcrCustomizedData ? "Guidelines" : "Receipt Upload Guidelines" }}
      </h5>
      <!-- isOcrCustomized: true — show campaign terms_and_condition HTML -->
      <div
        v-if="isOcrCustomizedData && termsCondition"
        class="guidelines-html-content"
        v-html="termsCondition"
      ></div>
      <!-- isOcrCustomized: false — show default customized guidelines -->
      <template v-else>
        <div v-for="(guidelines, title) in customizedGuidelines" :key="title">
          <p class="guideline-title">{{ title }}</p>
          <ul class="upload-receipt-guidelines">
            <li
              v-for="(guideline, index) in guidelines"
              :key="`customized-upload-receipt-guideline-${index}`"
            >
              {{ guideline }}
            </li>
          </ul>
        </div>
      </template>
    </div>
    <b-button
      block
      pill
      id="button-upload-receipt-guideline-got-it"
      @click="closeDrawer"
      :class="{ 'for-desktop mx-auto': isModal && !isOcrCustomizedData }"
      :style="themeColor ? { backgroundColor: themeColor, borderColor: themeColor } : {}"
      >{{ isOcrCustomizedData ? "Close" : "Got it" }}</b-button
    >
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "UploadReceiptGuidelinesDrawer",
  props: {
    isModal: {
      type: Boolean,
      default: () => false
    },
    modalId: {
      type: String,
      default: () => null
    }
  },
  computed: {
    ...mapState("utilityStore", {
      drawerData: state => state.drawerData
    }),
    termsCondition() {
      return this.drawerData?.terms_condition || null;
    },
    isOcrCustomizedData() {
      return this.drawerData?.isOcrCustomized || false;
    },
    themeColor() {
      return this.drawerData?.theme_color || null;
    },
    staticGuidelines() {
      return [
        "Each receipt must contain at least one NutriAsia product to qualify.",
        "Place the receipt on a flat surface before taking a photo",
        "Keep each file under 2mb",
        "Make sure all details are clear and easy to read"
      ];
    },
    customizedGuidelines() {
      return {
        "Points Earning": ["Each valid receipt earns 1 point"],
        Eligibility: [
          "Receipt must be from an eligible store, such as Supermarkets, Hypermarkets, Convenience stores, Warehouse clubs (e.g., Landers, S&R), or E-commerce stores (e.g., Lazada, Shopee)",
          "Valid only within 7 days of the purchase date"
        ],
        "Photo Quality": [
          "Place the receipt on a flat surface before taking a photo",
          "Keep each file under 2mb",
          "Make sure all details are clear and easy to read"
        ]
      };
    }
  },
  methods: {
    closeDrawer() {
      if (!this.isModal) this.$emit("closeDrawer");
      else this.$root.$emit("bv::hide::modal", this.modalId);
    }
  }
};
</script>

<style lang="scss" scoped>
#upload-receipt-guidelines-drawer {
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  padding: 32px 28px 31px;

  .guidelines-scroll-content {
    overflow-y: auto;
    flex: 1;
  }

  h5 {
    color: #2f3941;
    font-family: "SKModernistBold", sans-serif;
    font-size: 1.375rem;
    margin-bottom: 24px;
  }

  .guideline-title {
    color: #2f3941;
    font-family: "SKModernistBold", sans-serif;
    font-size: 16px;
    margin-bottom: 8px;
  }

  // Styles for v-html rendered rich text (terms_condition)
  .guidelines-html-content {
    color: #68737d;
    font-size: 14px;
    line-height: 1.6;

    ::v-deep ul {
      padding-left: 1.25rem;
      margin-bottom: 12px;

      li {
        color: #68737d;
        font-size: 14px;
        margin-bottom: 10px;
      }
    }

    ::v-deep ol {
      padding-left: 1.25rem;
      margin-bottom: 12px;

      li {
        color: #68737d;
        font-size: 14px;
        margin-bottom: 10px;
      }
    }

    ::v-deep p {
      font-size: 14px;
      color: #68737d;
      margin-bottom: 10px;
    }
  }

  ul.upload-receipt-guidelines {
    list-style-type: none;
    margin: 0;
    padding: 0;

    li {
      color: #68737d;
      font-size: 1rem;
      display: flex;
      margin-bottom: 15px;

      &::before {
        content: "";
        width: 14px;
        height: 14px;
        flex-shrink: 0;
        background: url("~@/assets/images/check.svg") no-repeat;
        background-size: contain;
        display: inline-block;
        margin-right: 10px;
      }
    }
  }

  #button-upload-receipt-guideline-got-it {
    background: var(--main-color);
    border: 0;
    font-family: "SKModernistBold", sans-serif;
    font-size: 1rem;
    height: 50px;
    margin-top: 24px;
    flex-shrink: 0;

    &.for-desktop {
      width: 184px;
      height: 44px;
    }
  }

  &.for-desktop {
    h5 {
      font-size: 1.25rem;
    }
  }
}
</style>
